import React from 'react';
import { PropTypes, richTextPropTypes } from 'prop-types';
import { VisuallyHidden } from '../styled/accessibility';
import RichText from '../rich-text';
import iconSrc from '../../utils/iconSrc';

// Styles
import {
  Alert,
  BannerWrapper,
  AlertTextWrapper,
  BannerTitleWrapper,
  Close,
  Icon,
  WarningIcon,
} from './styles';

const Banner = ({ bannerTitle, text, handler }) => (
  <Alert
    role="region"
    aria-label="banner"
    data-nosnippet
    data-funnelbacknoindex
  >
    <BannerWrapper>
      <AlertTextWrapper>
        <BannerTitleWrapper>
          <>
            <VisuallyHidden>Warning icon</VisuallyHidden>
            <WarningIcon
              src={iconSrc('alert-warning')}
              aria-hidden="true"
              cacheRequests
            />
          </>
          <strong>{bannerTitle}</strong>
        </BannerTitleWrapper>
        <RichText richText={text} />
      </AlertTextWrapper>

      <Close
        type="button"
        onClick={(event) => {
          event.preventDefault();
          handler();
        }}
      >
        <VisuallyHidden>Dismiss this banner </VisuallyHidden>
        <Icon src={iconSrc('cross')} aria-hidden="true" cacheRequests />
      </Close>
    </BannerWrapper>
  </Alert>
);

Banner.propTypes = {
  bannerTitle: PropTypes.string.isRequired,
  text: PropTypes.shape(richTextPropTypes).isRequired,
  handler: PropTypes.func,
};
export default Banner;
